import React, { useState } from "react";


import {
    Button,
    ConfirmDialog,
    LabeledField,
    SectionCard,
    Spinner,
    TextInput,
    UploadDropzone,
} from "shared/ui";
import {
    IMAGE_UPLOAD_ACCEPT,
    SUPPLIER_LOGO_MAX_BYTES,
    imageUploadHint,
    validateImageFile,
} from "shared/lib/mediaUpload";
import { uploadSupplierLogo } from "services/uploads/rest";

import { useMenuItemEditorContext } from "features/MenuItemEditor/context";

import { LogoImg, LogoRow } from "./styles";

export const ExtraTab = () => {
    const state = useMenuItemEditorContext();
    const [uploading, setUploading] = useState<boolean>(false);
    const [confirmOpen, setConfirmOpen] = useState<boolean>(false);

    const onDropLogo = async (files: File[]) => {
        if (files.length === 0) return;

        const error = validateImageFile(files[0], SUPPLIER_LOGO_MAX_BYTES);

        if (error !== null) {
            state.notify.showError(error);
            return;
        }

        setUploading(true);
        try {
            const res = await uploadSupplierLogo(files[0]);
            state.setSupplierLogoUrl(res.url);
        } catch (e) {
            state.notify.showError("Не удалось загрузить изображение", e);
        } finally {
            setUploading(false);
        }
    };

    return (
        <>
            <SectionCard
                title="AR-код для позиции"
                description="Гость сможет посмотреть блюдо в дополненной реальности"
            >
                <LabeledField label="Ссылка на 3D модель">
                    <TextInput
                        value={state.arCodeLink}
                        onChange={state.setArCodeLink}
                        placeholder="https://"
                    />
                </LabeledField>
            </SectionCard>

            <SectionCard
                title="Логотип поставщика"
                description="Показывается в карточке позиции. Большой логотип уменьшится сам"
            >
                {uploading ? (
                    <Spinner color="secondary" />
                ) : state.supplierLogoUrl ? (
                    <LogoRow>
                        <LogoImg src={state.supplierLogoUrl} alt="" />
                        <Button
                            variant="text"
                            color="danger"
                            onClick={() => state.setSupplierLogoUrl(null)}
                        >
                            Удалить
                        </Button>
                    </LogoRow>
                ) : (
                    <UploadDropzone
                        onDrop={onDropLogo}
                        width={150}
                        height={150}
                        accept={IMAGE_UPLOAD_ACCEPT}
                        hint={imageUploadHint(SUPPLIER_LOGO_MAX_BYTES)}
                    />
                )}
            </SectionCard>

            <SectionCard
                tone="danger"
                title="Удаление позиции"
                description="Позиция исчезнет из меню и из всех наборов. Действие нельзя отменить."
            >
                <Button variant="outlined" color="danger" onClick={() => setConfirmOpen(true)}>
                    Удалить карточку
                </Button>
            </SectionCard>

            <ConfirmDialog
                open={confirmOpen}
                title="Удалить позицию?"
                description="Позиция исчезнет из меню. Действие необратимо."
                confirmLabel="Удалить"
                saving={state.deleting}
                onClose={() => setConfirmOpen(false)}
                onConfirm={state.deleteItem}
            />
        </>
    );
};
